import React from "react";
import "../styles/Home.css";
import backgroundImage from "../assets/background.PNG";
import PIC from "../assets/PIC.png";

const Home = () => {
  return (
    <div
      className="home-container"
      style={{ backgroundImage: `url(${PIC})` }}
    >
      {/* <div className="home-card">
        <h1 className="home-title">
          <b>Welcome To ECL Shipping India Pvt. Ltd</b>
        </h1>

        <p className="home-text">
          ECL Shipping India Pvt Ltd was established in 2006 as a joint venture
          of PUYVAST Maritime India Pvt Ltd and ECL (Singapore) Pte Ltd, a 100
          percent subsidiary of M/s. Eastern Car Liner, Japan.
        </p>

        <p className="home-text">
          ECL-Shipping acts as the General Agent in India for M/s. Eastern Car
          Liner, one of the largest operators from Japan.
        </p>
      </div> */}
    </div>
  );
};

export default Home;
